<template>

  <div class="content" v-loading="loading">

    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
    <div class="mb-3 row">


      <div class="col-3 nowrap">

        <el-button icon="el-icon-arrow-left" circle @click.prevent="dateMove(-1)"></el-button>
        <el-date-picker
          v-model="selectedDate"
          type="date" @change="getOrders"
          placeholder="Pick a day">
        </el-date-picker>
        <el-button icon="el-icon-arrow-right" circle @click.prevent="dateMove(1)"></el-button>
      </div>
      <div class="col-3">
        <el-button-group v-if="rooms && rooms.length">
          <el-button v-for="room in rooms" :key="room._id" @click="selectRoom(room)" :type="room._id === (selectedRoom && selectedRoom._id) ? 'primary' : ''" size="small">{{room.title}}</el-button>
        </el-button-group>
      </div>
      <div class="col-3 nowrap">

        <el-button icon="el-icon-arrow-left" circle @click.prevent="timeMove(-15)"></el-button>
        <el-time-select v-model="selectedTime" :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="Select time"></el-time-select>
        <el-button icon="el-icon-arrow-right" circle @click.prevent="timeMove(15)"></el-button>

      </div>

    </div>

    <view-room v-if="selectedRoom" :rooms="rooms" :orders="orders" :time="selectedTime" :room="selectedRoom" @new-order="createNewOrder" @edit-order="editOrder" />

    <el-dialog :title="newOrder._id ? 'Editing of order' : 'Create new order'" :visible.sync="showNewOrder">

      <div v-if="loadingOrder">
        Loading...
      </div>
      <div v-else>
        <div v-if="newOrder">
        <create-order-dialog :rooms="rooms" :item="newOrder" @create="onCreateOrder" @deleted="onCreateOrder" @cancel="onCreateOrder"></create-order-dialog>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 140px;
  }
  .nowrap {
    white-space: nowrap;
  }
</style>
<script>
  import moment from 'moment'
  import axios from '../store/my-axios'
  import ViewRoom from './ViewRoom';
  import CreateOrderDialog from '../components/CreateOrderDialog';

  function round(date, duration, method) {
    return moment(Math[method]((+date) / (+duration)) * (+duration));
  }
  export default {
    components: {
      ViewRoom,
      CreateOrderDialog
    },
    computed: {
      accountSettings() {
        return this.$store.state.accountSettings;
      }
    },
    data() {
      return {
        selectedDate: new Date(),
        selectedTime: round(new Date(), moment.duration(15, "minutes"), 'ceil').format('HH:mm'),
        newOrder: {},
        showNewOrder: false,
        loadingOrder: false,
        loading: false,
        rooms: [],
        orders: [],
        selectedRoom: null
      };
    },
    async mounted() {
      this.loading = true;
      await this.$store.dispatch('getAccountSettings');

      if (this.accountSettings.reservation && this.accountSettings.reservation.rooms) {
        this.rooms = this.accountSettings.reservation.rooms;
      } else {
        this.rooms = [];
      }
      this.selectedRoom = this.rooms[0];

      await this.getOrders();
      this.loading = false;
    },
    methods: {
      async getOrders() {
        const { data } = await axios.get(`/v1/reservations`, { params: { accountId: this.$store.state.accountId, date: moment(this.selectedDate).format('DD-MM-YYYY') } });
        this.orders = data;
      },

      async dateMove(sup) {
        this.loading = true;
        this.selectedDate = moment(this.selectedDate).add(sup, 'day').toDate();
        await this.getOrders();
        this.loading = false;
      },
      async timeMove(sup) {
        this.loading = true;
        this.selectedTime = moment(`${moment().format('DD-MM-YYYY')} ${this.selectedTime}`, 'DD-MM-YYYY HH:mm').add(sup, 'minutes').format('HH:mm');
        this.loading = false;
      },

      selectRoom(room) {
        this.selectedRoom = room;
      },
      async onCreateOrder() {
        await this.getOrders();
        this.showNewOrder = false;
      },
      async editOrder(order) {
        order.reservation.reservationTime = moment(order.reservation.reservationDate).format('HH:mm');
        this.showNewOrder = true;
        this.loadingOrder = true;
        try {
          const { data } = await axios.get(`/v1/reservations/${order._id}`, { params: { accountId: this.$store.state.accountId } });
          this.newOrder = data;
        } catch (err) {

        }
        this.loadingOrder = false;
      },
      createNewOrder() {
        this.newOrder = {
          account: {
            _id: this.$store.state.accountId
          },
          reservation: {
            reservationDate: new Date(),
            reservationTime: '18:00',
            leavingTime: null,
            partySize: 2,
            reservationTables: []
          }
        };
        this.showNewOrder = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Reservations.vue?823ffbce